import { atom } from 'recoil';

export const spMenuOpenAtom = atom<boolean>({
  key: 'spMenuOpenAtom',
  default: false,
});
